// Date helpers — dynamic, never hard-coded.

const pad = (n) => String(n).padStart(2, "0");

export const todayDDMMYYYY = (sep = "-") => {
  const d = new Date();
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join(sep);
};

export const todayLong = () => {
  const d = new Date();
  return d.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};
